import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import EventIcon from '@mui/icons-material/Event';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  useTheme,
  Button,
  Tooltip,
  Avatar,
  ListItemIcon,
  Typography,
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';

import { PAGE_ROUTES } from '@common/constants';
import { updateFavicon } from '@common/helpers/helpers';
import { useAuthStore } from '@store/authStore';

const MenuBar = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { t } = useTranslation();
  const { logout, userName, setColorMode, colorMode } = useAuthStore();

  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleMenuClose();
    logout();
  };

  const onTemplatesClick = () => {
    navigate(PAGE_ROUTES.TEMPLATES);
  };

  useEffect(() => {
    updateFavicon(require(`../../../assets${theme?.favicon}`));
  }, []);

  return (
    <Box
      sx={{
        ...theme.header,
        display: 'flex',
        alignItems: 'center',
        px: 2,
        zIndex: 100,
        position: 'relative',
      }}
    >
      <Box sx={{ mr: 1 }}>
        <Box
          component='img'
          src={require('../../../assets/' + theme.logoName)}
          alt='Company Logo'
          onClick={onTemplatesClick}
          sx={{
            height: '25px',
            width: 'auto',
            cursor: 'pointer',
            padding: '1rem',
            paddingLeft: 0,
            paddingRight: '3px',
            marginTop: '5px',
          }}
        />
        {theme.logoIconName && (
          <Box
            component='img'
            src={require('../../../assets/' + theme.logoIconName)}
            alt='Company Logo'
            onClick={onTemplatesClick}
            sx={{
              height: '25px',
              width: 'auto',
              cursor: 'pointer',
              padding: '1rem',
              paddingLeft: 0,
              marginTop: '5px',
            }}
          />
        )}
      </Box>
      <Box>
        <Button sx={theme.headerItem} onClick={onTemplatesClick}>
          {t('templates')}
        </Button>
      </Box>
      <Box sx={{ marginLeft: 'auto' }}>
        <Tooltip
          title={`${t('toggle_dark_mode')} ${
            colorMode === 'light' ? t('on') : t('off')
          }`}
        >
          <IconButton
            size='small'
            onClick={() =>
              setColorMode(colorMode === 'light' ? 'dark' : 'light')
            }
            disableRipple
            sx={{
              mr: 2,
              color: (theme) => theme?.palette?.background?.primary,
              backgroundColor: (theme) => theme?.headerItem?.backgroundColor,
            }}
          >
            {colorMode === 'light' ? <Brightness4Icon /> : <Brightness7Icon />}
          </IconButton>
        </Tooltip>
        <Tooltip title={t('open_tem')}>
          <IconButton
            size='small'
            disableRipple
            sx={{
              mr: 2,
              color: (theme) => theme?.palette?.background?.primary,
              backgroundColor: (theme) => theme?.headerItem?.backgroundColor,
            }}
            onClick={(e) => {
              e.preventDefault();
              window.open(`${process.env.REACT_APP_TEM_APP_URL}`, '_blank');
            }}
            color='inherit'
          >
            <EventIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title={t('open_settings')}>
          <IconButton size='small' onClick={handleMenuOpen} color='inherit'>
            {userName ? (
              <Avatar
                sx={{
                  textTransform: 'uppercase',
                  width: 32,
                  height: 32,
                  backgroundColor: (theme) =>
                    theme?.headerItem?.backgroundColor,
                  color: (theme) => theme?.palette?.background?.primary,
                }}
              >
                {userName[0]}
              </Avatar>
            ) : (
              <AccountCircleIcon />
            )}
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <Typography>{t('logout')}</Typography>
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default MenuBar;
